<template>
  <div
    v-if="visible"
    class="maintenance-banner w-full d-flex p-1 mb-2 align-items-center"
    style="gap: 1rem"
  >
    <div class="banner-icon">
      <b-img
        src="@/assets/duplioAsset/icons/alert.png"
        blank-color="#ccc"
        width="48"
        alt="alert"
      />
    </div>

    <div class="flex-grow-1">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <h5 class="mb-1 font-weight-bold text-warning-dark">
            {{ $t(locale.title) }}
          </h5>
          <p class="mb-0 text-dark">
            {{ $t(locale.message) }}
          </p>
        </div>
        <b-button
          variant="link"
          class="close-btn p-0 ml-2"
          @click="closeBanner"
        >
          <feather-icon icon="XIcon" size="20" class="text-dark" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * MaintenanceBanner Component
 *
 * Displays a maintenance notification banner on dashboard pages.
 *
 * To control visibility:
 * - Set maintenanceEnabled in Vuex store (src/store/app-config/index.js) to true/false
 * - The banner can be dismissed by users (stored in sessionStorage and Vuex)
 * - Users can re-open the banner by clicking the warning triangle in the navbar
 */
export default {
  name: "MaintenanceBanner",
  data() {
    return {
      locale: {
        title: "Message.maintenanceTitle",
        message: "Message.maintenanceMessage",
      },
    };
  },
  computed: {
    ...mapGetters({
      maintenanceEnabled: "appConfig/getMaintenanceEnabled",
      bannerDismissed: "appConfig/getMaintenanceBannerDismissed",
    }),
    visible() {
      // Only show if maintenance is enabled and banner is not dismissed
      return this.maintenanceEnabled && !this.bannerDismissed;
    },
  },
  mounted() {
    // Check if banner was previously closed in this session
    const bannerClosed = sessionStorage.getItem("maintenanceBannerClosed");
    if (bannerClosed === "true") {
      this.$store.commit("appConfig/SET_MAINTENANCE_BANNER_DISMISSED", true);
    }
  },
  methods: {
    closeBanner() {
      // Store in session storage and Vuex
      sessionStorage.setItem("maintenanceBannerClosed", "true");
      this.$store.commit("appConfig/SET_MAINTENANCE_BANNER_DISMISSED", true);
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  background-color: #fff4e5;
  border: 2px solid #ffb020;
  border-radius: 12px;
  padding: 1rem !important;
}

.banner-icon {
  flex-shrink: 0;
}

.text-warning-dark {
  color: #b54708;
}

.close-btn {
  flex-shrink: 0;
  line-height: 1;
  background: transparent;
  border: none;
  box-shadow: none !important;
}

.close-btn:hover {
  opacity: 0.7;
}
</style>
